import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from "@angular/common/http";
import { authDavesaApiInterceptor } from "app/core/auth-davesa/auth-davesa-api.interceptor";
import { ApplicationConfig, inject, provideAppInitializer, LOCALE_ID } from "@angular/core";
import { LuxonDateAdapter } from "@angular/material-luxon-adapter";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { provideAnimations } from "@angular/platform-browser/animations";
import {
  PreloadAllModules,
  provideRouter,
  withInMemoryScrolling,
  withPreloading,
} from "@angular/router";
import { provideDavesa } from "../@davesa";
import { TranslocoService, provideTransloco } from "@ngneat/transloco";
import { provideAuthorization } from "app/core/auth/auth.provider";
import { provideIcons } from "app/core/icons/icons.provider";
import { mockApiServices } from "./mock-api";
import { firstValueFrom } from "rxjs";
import { TranslocoHttpLoader } from "app/core/transloco/transloco.http-loader";
import { provideAuthDavesaApi } from "app/core/auth-davesa/auth-davesa-api.provider";
import { appRoutes } from "./app.routes";
import { STANDARD_DATE_FORMATS } from "app/core/providers/date-formats.config";
import { firebaseProvideAuth } from "./core/auth-davesa/firebase-auth.provider";

// const auth2Interceptor = inject(Auth2Interceptor);

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    firebaseProvideAuth(),
    provideAuthorization(),
    provideAuthDavesaApi(),
    provideHttpClient(withInterceptors([authDavesaApiInterceptor]), withFetch()),
    provideRouter(
      appRoutes,
      withPreloading(PreloadAllModules),
      withInMemoryScrolling({ scrollPositionRestoration: "enabled" })
    ),

    // Material Date Adapter
    {
      provide: DateAdapter,
      useClass: LuxonDateAdapter,
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: STANDARD_DATE_FORMATS,
    },

    // Transloco Config
    provideTransloco({
      config: {
        availableLangs: [
          {
            id: "en",
            label: "English",
          },
          {
            id: "tr",
            label: "Turkish",
          },
        ],
        defaultLang: "en",
        fallbackLang: "en",
        reRenderOnLangChange: true,
        prodMode: true,
      },
      loader: TranslocoHttpLoader,
    }),
    provideAppInitializer(() => {
        const initializerFn = (() => {
        const translocoService = inject(TranslocoService);
        const defaultLang = translocoService.getDefaultLang();
        translocoService.setActiveLang(defaultLang);

        return () => firstValueFrom(translocoService.load(defaultLang));
      })();
        return initializerFn();
      }),

    // Davesa
    provideIcons(),
    provideDavesa({
      mockApi: {
        delay: 0,
        services: mockApiServices,
      },
      davesa: {
        layout: "classy",
        scheme: "light",
        screens: {
          sm: "600px",
          md: "960px",
          lg: "1280px",
          xl: "1440px",
        },
        theme: "theme-default",
        themes: [
          {
            id: "theme-default",
            name: "Default",
          },
          {
            id: "theme-brand",
            name: "Brand",
          },
          {
            id: "theme-teal",
            name: "Teal",
          },
          {
            id: "theme-rose",
            name: "Rose",
          },
          {
            id: "theme-purple",
            name: "Purple",
          },
          {
            id: "theme-amber",
            name: "Amber",
          },
        ],
      },
    }),
  ],
};
